import React from 'react'
import PropTypes from 'prop-types'
import * as StringFormatter from '../../../../global/formatters/string-formatter.js'
import { getRelativeBasePath } from '../../../../global/environments/path.js'

function FundHeaderMessage({ fund }) {
  const { messageContents } = fund
  let content = ''

  if (messageContents) {
    const hasMergerFund =
      messageContents.mergerFund && messageContents.mergerFund.mergerDate
    const hasRenameFund =
      messageContents.renameFund && messageContents.renameFund.renameMessage
    const hasClosedFundMessage = !!messageContents.closedFundMessage

    if (hasMergerFund) {
      const mergerFund = messageContents.mergerFund
      const relativeBasePath = getRelativeBasePath()
      const targetFundNameUrl = mergerFund.targetFundName.replace(/\s/g, '-')
      const fundClass = 'Class-' + fund.className

      content = [
        'On ' +
          StringFormatter.formatDate(mergerFund.mergerDate, true, true) +
          ', ',
        mergerFund.mergedFundName + ' was acquired by ',
        mergerFund.targetFundName + '. ',
        'Information about ' + mergerFund.targetFundName,
        ' can be found <a href="',
        relativeBasePath + '/investment-products/mutual-funds/',
        targetFundNameUrl + '/',
        fundClass,
        '/details/?cusip=',
        mergerFund.targetFundCusip,
        '">here</a>. Please update your bookmarks.</a>',
      ].join('')
    }

    if (hasRenameFund) {
      if (hasMergerFund) {
        content += '<br />'
      }

      content += messageContents.renameFund.renameMessage
    }

    if (hasClosedFundMessage) {
      if (hasMergerFund || hasRenameFund) {
        content += '<br><br>'
      }

      content += messageContents.closedFundMessage
    }
  }

  return (
    <div className="u-sizeConstrained" id="fund-header-message">
      {content && (
        <div className="Card u-paddingBottom0 u-paddingTop3gu">
          <div className="Grid Grid--alignMiddle u-bgColorWhite u-paddingBottom4gu">
            <span className="alert-warning-legacy u-posAbsolute"></span>
            <div className="Content u-paddingLeft8gu u-size10of12 u-sm-sizeFill u-paddingBottom0">
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

FundHeaderMessage.propTypes = {
  fund: PropTypes.object.isRequired,
  messageContents: PropTypes.object,
  fundHeader: PropTypes.object,
}

export default FundHeaderMessage
